export const ALL_TASKS = 'task/all'; //#DONE
export const ALL_TASKS_AND_SUBTASKS = 'task/all-with-subtasks'; //#!DONE
export const CREATE_TASK = `task/store`; // #!DONE
export const SHOW_TASK = {
    // #!DONE
    TASK: (taskId) => `task/${taskId}/show`,
};
export const UPDATE_TASK = {
    // #!DONE
    TASK: (taskId) => `task/${taskId}/update`,
};
export const DELETE_TASK = { 
    // #!DONE
    TASK: (taskId) => `task/${taskId}/delete`,
};

// Subtasks
export const ALL_SUBTASKS = `subTask/all`; // #!DONE
export const CREATE_SUBTASK = `subTask/store`; // #!DONE
export const SHOW_SUBTASK = {
    // #!DONE - allow us to pass JSON
    SUBTASK: (subTaskId) => `subTask/${subTaskId}/show`,
};
export const DELETE_SUBTASK = {
    SUBTASK: (subTaskId) => `subTask/${subTaskId}/delete`,
};
